import { Action, createReducer } from '@ngrx/store';
import { produceOn } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { AffiliateProfile } from '@core/utils/models/affiliate.model';
import { AffiliateActions } from '../actions/affiliate.actions';

export const affiliateFeatureKey = 'affiliate';

export interface State {
  hash: string | null;
  profile: {
    data: AffiliateProfile | null;
    httpState: HttpState;
  };
}

export const initialState: State = {
  hash: null,
  profile: {
    data: null,
    httpState: HttpStateHandler.initialState,
  },
};

export const affiliateReducer = createReducer(
  initialState,
  produceOn(AffiliateActions.setHash, (draft, action) => {
    draft.hash = action.hash;
  }),
  /** get profile */
  produceOn(AffiliateActions.getProfile, (draft, action) => {
    draft.profile = {
      data: initialState.profile.data,
      httpState: HttpStateHandler.loading(draft.profile.httpState, action),
    };
  }),
  produceOn(AffiliateActions.getProfileSuccess, (draft, action) => {
    draft.profile = {
      data: action.data,
      httpState: HttpStateHandler.success(draft.profile.httpState, action),
    };
  }),
  produceOn(AffiliateActions.getProfileFailure, (draft, action) => {
    draft.profile.httpState = HttpStateHandler.error(draft.profile.httpState, action);
  })
);

export function reducer(state: State | undefined, action: Action) {
  return affiliateReducer(state, action);
}
